import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('productPage',{attrs:{"pageData":this.page,"productData":this.products[_vm.$route.params.id]}}),_c(VContainer)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }